import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import reviewAndPublishServices from '../services/reviewAndPublishServices';
import { ApiState } from '../constants/enums';
import { IScheduleTaxBreakup, IScheduleTaxBreakupResponse } from '../types/reviewAndPublish.type';

export interface ReviewAndPublishState {
    apiState: {
        getTaxScheduleBreakup: ApiState;
    };
    taxScheduleBreakup: IScheduleTaxBreakup[];
}

const initialState: ReviewAndPublishState = {
    apiState: {
        getTaxScheduleBreakup: ApiState.NOT_STARTED,
    },
    taxScheduleBreakup: [],
};
export const getTaxScheduleBreakupDetails = createAsyncThunk<IScheduleTaxBreakupResponse, { scheduleId: string }>(
    'review-publish/get-tax-schedule-breakup',
    async ({ scheduleId }) => {
        return reviewAndPublishServices.getTaxScheduleBreakup(scheduleId).then((res) => res);
    },
);

const reviewAndPublishSlice = createSlice({
    name: 'reviewAndPublish',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getTaxScheduleBreakupDetails.pending, (state) => {
                state.apiState.getTaxScheduleBreakup = ApiState.PENDING;
            })
            .addCase(
                getTaxScheduleBreakupDetails.fulfilled,
                (state, action: PayloadAction<IScheduleTaxBreakupResponse>) => {
                    state.taxScheduleBreakup = action.payload.data.layerDetails || [];
                    state.apiState.getTaxScheduleBreakup = ApiState.FULFILLED;
                },
            )
            .addCase(getTaxScheduleBreakupDetails.rejected, (state) => {
                state.apiState.getTaxScheduleBreakup = ApiState.REJECTED;
            });
    },
    reducers: {},
});

// export const {} = reviewAndPublishSlice.actions;

export default reviewAndPublishSlice.reducer;
